import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { BulkChangePanel, Col } from 'components/misc'
import { bulkChange } from 'helpers/decorators'
import { logError, modal, notification, onRefreshPage } from 'redux/modules/app'
import { Select } from 'components/fields'
import { BulkActionResultsModal, BulkChangeApprovalModal } from 'components/modals'
import { injectIntl } from 'react-intl'
import { INVITED_PARTICIPANTS_BULK } from 'constants/enums'
import * as invitedParticipantsApi from 'redux/modules/api/tasks/tasks-invited-participants'
import * as bulkApi from 'redux/modules/api/bulk'
import { bulkInvitedParticipantsOptions, bulkForm } from 'constants/layout/tasks/tasks-invited-participants'

@connect(
  ({ api }) => ({
    bulkState: api.tasks.invitedParticipants.bulk,
    bulkResult: api.bulk.bulkChangeResult
  }),
  {
    setSelected: invitedParticipantsApi.setTasksInvitedParticipantsSelected,
    bulkReset: invitedParticipantsApi.bulkInvitedParticipantsReset,
    bulkProcess: invitedParticipantsApi.bulkInvitedParticipantsProcess,
    bulkSetResult: bulkApi.setBulkChangeResult,
    notification,
    logError,
    onRefreshPage,
    modal
  }
)
@bulkChange({
  form: bulkForm,
  persist: false,
  initialValues: {
    bulkType: null
  }
})
@injectIntl
class BulkInvitedParticipants extends Component {
  static propTypes = {
    selectedIds: PropTypes.array.isRequired,
    setSelected: PropTypes.func,
    bulkState: PropTypes.object,
    bulkReset: PropTypes.func,
    bulkResult: PropTypes.object,
    bulkProcess: PropTypes.func,
    bulkSetResult: PropTypes.func,
    bulkFormValues: PropTypes.object,
    intl: PropTypes.object,
    notification: PropTypes.func,
    logError: PropTypes.func,
    onRefreshPage: PropTypes.func,
    modal: PropTypes.func,
  }


  handleClearSelection = () => {
    this.props.setSelected([])
  }

  handleBulkActionFinished = () => {
    this.props.modal(null)
    this.props.onRefreshPage()
  }

  getModalByBulkType() {
    const bulkType = this.props.bulkFormValues.bulkType

    switch (bulkType) {
      case INVITED_PARTICIPANTS_BULK.resendInvitationEmail.id:
        this.props.modal('bulk-invited-participants-resend-invitation-email-modal')
        break
      case INVITED_PARTICIPANTS_BULK.delete.id:
        this.props.modal('bulk-invited-participants-delete-modal')
        break
      default:
    }
  }

  handleError = err => {
    this.props.logError(err)
    this.props.modal(null)
    if (err && err.body) {
      console.debug('error', err.body && err.body.userMessage)
      this.props.notification(err.body.userMessage || 'Error', 'error')
    }
  }

  handleBulkActionApprove = () => {
    const bulkType = this.props.bulkFormValues.bulkType

    this.props.bulkProcess(this.props.selectedIds, bulkType)
      .then(data => {
        this.props.bulkSetResult(data.body)
        this.props.modal(null)
        this.props.modal('bulk-invited-participants-results-modal')
      })
      .catch(this.handleError)
  }

  render() {
    const {
      selectedIds,
      bulkReset,
      bulkResult,
      bulkState: { loading } = { },
      intl
    } = this.props

    return (
      <div>
        <BulkChangePanel
          selectedCount={selectedIds && selectedIds.length}
          onClearSelection={this.handleClearSelection}
          onBulkChange={() => {
            bulkReset()
            this.getModalByBulkType()
          }}
        >
          <Col flex="0 1 200px" alignSelf="center">
            <Select
              intlKeyPlaceholder="label.bulk_operations"
              options={bulkInvitedParticipantsOptions(intl)}
              onSelectChange={field => this.props.setSelected(selectedIds, field.value)}
              name="bulkType"
            />
          </Col>
        </BulkChangePanel>

        <BulkChangeApprovalModal
          modalId="bulk-invited-participants-resend-invitation-email-modal"
          isLoading={loading}
          itemCount={selectedIds.length}
          onApprove={this.handleBulkActionApprove}
        />

        <BulkChangeApprovalModal
          modalId="bulk-invited-participants-delete-modal"
          isLoading={loading}
          itemCount={selectedIds.length}
          onApprove={this.handleBulkActionApprove}
        />

        <BulkActionResultsModal
          modalId="bulk-invited-participants-results-modal"
          successfulCount={bulkResult.successfulCount}
          unsuccessfulCount={bulkResult.unsuccessfulCount}
          errorResults={bulkResult.bulkErrorResults}
          onConfirmed={this.handleBulkActionFinished}
        />
      </div>
    )
  }
}

export default BulkInvitedParticipants
